// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2vfSi","content":"LayoutSettings_content__3oEdl"};